import { render } from "./BusinessGroupIdentityForm.vue?vue&type=template&id=7467789b&scoped=true"
import script from "./BusinessGroupIdentityForm.vue?vue&type=script&lang=js"
export * from "./BusinessGroupIdentityForm.vue?vue&type=script&lang=js"

import "./BusinessGroupIdentityForm.vue?vue&type=style&index=0&id=7467789b&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7467789b"]])

export default __exports__